import React, {useState} from 'react';
import {connect} from 'react-redux'
import {
    AppBar,
    Card,
    CardContent, Icon, IconButton,
    Toolbar,
    Typography
} from '@material-ui/core';
import {withRouter} from "react-router-dom";
import {withStyles} from "@material-ui/core/styles";
import {bindActionCreators} from "redux";
import ReduxMission from "../../../../../store/actionreducers/mission";
import ReduxGlobal from "../../../../../store/actionreducers/globalView";

const numberOfRowsInTextField = 7

const NoticeTab = ({tempMission, postNoticeByAdminMedical, openAlertDialog, openLoadingMask, closeLoadingMask}) => {

    const [actionType, setActionType] = useState('view') // view and edit
    const [notice, setNotice] = useState(tempMission.medicalSuggest.notice || '')

    return (
        <div>
            <Card className="w-full mb-16">
                <AppBar position="static" elevation={2}>
                    <Toolbar className="pl-16 pr-8">
                        <Typography variant="subheading" color="inherit" className="flex-1">
                            醫師建議
                        </Typography>
                    </Toolbar>
                </AppBar>

                <CardContent>
                    <div className="mb-24">
                        <Typography>{tempMission.medicalSuggest
                            ? `${tempMission.medicalSuggest.suggestion}：${tempMission.medicalSuggest.detail}`
                            : '（無）'}</Typography>
                    </div>
                </CardContent>
            </Card>
            {actionType === 'view' && <Card className="w-full mb-16">
                <AppBar position="static" elevation={2}>
                    <Toolbar className="pl-16 pr-8">
                        <Typography variant="subheading" color="inherit" className="flex-1">
                            備註
                        </Typography>
                        <IconButton
                            onClick={() => {
                                setActionType('edit')
                            }}
                        >
                            <Icon className="text-white">mode_edit</Icon>
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <CardContent>
                    <div className="mb-24">
                        <Typography>{tempMission.medicalSuggest ? `${tempMission.medicalSuggest.notice}` : '（無）'}</Typography>
                    </div>
                </CardContent>
            </Card>}
            {actionType === 'edit' && <Card className="w-full mb-16">
                <AppBar position="static" elevation={2} color="secondary">
                    <Toolbar className="pl-16 pr-8">
                        <Typography variant="subheading" color="inherit" className="flex-1">
                            備註
                        </Typography>
                        <IconButton
                            onClick={() => {
                                const alertDialogInfo = {
                                    title: '離開編輯畫面',
                                    message: `若您尚未儲存，您所填寫的資料將會遺失，請問您是否要離開?`,
                                    yesButton: {
                                        label: '是',
                                        onClick: () => {
                                            setActionType('view')
                                        },
                                    },
                                    noButton: {label: '否'}
                                }
                                openAlertDialog(alertDialogInfo)
                            }}
                        >
                            <Icon className="text-white">cancel</Icon>
                        </IconButton>
                        <IconButton
                            onClick={async () => {
                                openLoadingMask()
                                try {
                                    await postNoticeByAdminMedical({
                                        id: tempMission.medicalSuggest.id,
                                        medicalSuggest: {
                                            notice,
                                        }
                                    })
                                    setActionType('view')
                                } catch (e) {
                                    console.warn('error = ', e)
                                }
                                closeLoadingMask()
                            }}
                        >
                            <Icon className="text-white">save</Icon>
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <CardContent>
                    <textarea
                        className="flex w-full text-16 p-10"
                        value={notice || ''}
                        onChange={event => setNotice(event.target.value)}
                        rows={numberOfRowsInTextField}
                        style={styles().textArea}
                        placeholder={'請輸入給諮詢對象的備註內容'}
                    />
                </CardContent>
            </Card>}
        </div>
    )

}

const styles = () => ({
    textArea: {
        borderWidth: 1,
        borderColor: '#ddd',
        borderRadius: 10,
        lineHeight: 2.0,
        padding: 20,
        resize: "none",
        overflow: "hidden",
    },
})

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        postNoticeByAdminMedical: ReduxMission.ActionCreator.postNoticeByAdminMedical,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
        openAlertDialog: ReduxGlobal.ActionCreator.openAlertDialog,
    }, dispatch)
}

function mapStateToProps({mission: {temp: tempMission}}) {
    return {
        tempMission
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(NoticeTab)));



// WEBPACK FOOTER //
// ./src/main/content/adminMedical/mission/tabs/NoticeTab.js